module.exports = __webpack_public_path__ + "img/79800.508c6ffa.jpg";